import React from 'react'

const ChatDetailsModel = () => {
  return (
    <div>
      ChatDetails
    </div>
  )
}

export default ChatDetailsModel
